"use client";

import { GenericListPage, type GenericListConfig } from "@admin/_components/generic-list-page";

const config: GenericListConfig = {
  title: "Assignments",
  subtitle: "Manage training assignments",
  listEndpoint: "training-centre/assignment-list",
  countEndpoint: "training-centre/assignment-list-count",
  statusEndpoint: "training-centre/assignment-status-change",
  deleteEndpoint: "training-centre/assignment-delete",
  addPath: "/admin/training/assignments/add",
  editPath: "/admin/training/assignments/edit",
  addButtonLabel: "+ Add Assignment",
  previewEndpoint: "training-centre/assignment-preview",
  previewFields: [
    { key: "assignment_title", label: "Assignment Title" },
    { key: "lesson_name", label: "Lesson" },
    { key: "priority", label: "Priority" },
    { key: "assignment_description", label: "Description", type: "html" },
    { key: "status", label: "Status", type: "badge" },
    { key: "createdon_datetime", label: "Created At", type: "date" },
  ],
  columns: [
    { key: "assignment_title", label: "Assignment Title", sortable: true },
    { key: "lesson_name", label: "Lesson" },
    { key: "priority", label: "Priority", type: "number" },
    { key: "status", label: "Status", type: "status" },
    { key: "createdon_datetime", label: "Created At", type: "date", sortable: true },
  ],
  searchFields: [{ label: "Title", field: "assignment_title", placeholder: "Search by title..." }],
  filterFields: [
    { label: "Status", field: "status", values: [{ val: "1", name: "Active" }, { val: "0", name: "Inactive" }] },
  ],
};

export default function AssignmentsPage() {
  return <GenericListPage config={config} />;
}
